import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/solarpanel.png'
import _imports_1 from '@/assets/inverter.png'
import _imports_2 from '@/assets/building.png'
import _imports_3 from '@/assets/grid.png'


const _withScopeId = n => (_pushScopeId("data-v-0931118d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "gutter-row ant-col ant-col-15 box-sizing-border-box display-block",
  style: {"padding-left":"4px","padding-right":"4px"}
}
const _hoisted_2 = { class: "gutter-box height2 main-bd" }
const _hoisted_3 = { class: "h100pct posR normal-flowchart solarman-flowchart" }
const _hoisted_4 = { class: "content pd20x" }
const _hoisted_5 = { class: "default-flow-style" }
const _hoisted_6 = { class: "h100pct tableSys" }
const _hoisted_7 = { class: "vaT" }
const _hoisted_8 = { class: "ta-l" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dpIB",
  style: {"margin-top":"25px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "flow-icon-fd2"
  })
], -1))
const _hoisted_10 = {
  class: "dpIB posR",
  style: {"left":"10px","top":"20px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Production")
], -1))
const _hoisted_12 = { class: "font-w fs16x" }
const _hoisted_13 = { class: "pl40x" }
const _hoisted_14 = { class: "LDash active-line" }
const _hoisted_15 = {
  version: "1.1",
  viewBox: "0 0 61.5 137",
  style: {"width":"61.5px","height":"137px"}
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<polyline points=\"12,12 12,125 49.5,125\" stroke-width=\"4\" class=\"polyLine\" style=\"fill:none;\" data-v-0931118d></polyline><circle cx=\"12\" cy=\"12\" r=\"6\" stroke-width=\"0\" data-v-0931118d></circle><circle cx=\"-20\" cy=\"-20\" r=\"6\" stroke-width=\"0\" fill=\"#4C87FF\" data-v-0931118d><animateMotion path=\"M32,32 L32,145 L69.5,145 \" begin=\"0s\" dur=\"3s\" repeatCount=\"indefinite\" data-v-0931118d></animateMotion></circle><polygon points=\"49.5,125 45.5,133 61.5,125 45.5,117\" data-v-0931118d></polygon><circle cx=\"49.5\" cy=\"125\" r=\"1\" stroke-width=\"0\" data-v-0931118d></circle>", 5)
const _hoisted_21 = [
  _hoisted_16
]
const _hoisted_22 = { class: "no-wrap w80x vaT" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dpIB",
  style: {"margin-top":"203px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "flow-icon-cjq2"
  })
], -1))
const _hoisted_24 = { class: "LDash active-line" }
const _hoisted_25 = {
  version: "1.1",
  viewBox: "0 0 80 97",
  style: {"width":"80px","height":"97px"}
}
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<polyline points=\"40,12 40,85\" stroke-width=\"4\" class=\"polyLine\" style=\"fill:none;\" data-v-0931118d></polyline><circle cx=\"40\" cy=\"12\" r=\"6\" stroke-width=\"0\" data-v-0931118d></circle><circle cx=\"-20\" cy=\"-20\" r=\"6\" stroke-width=\"0\" fill=\"#4C87FF\" data-v-0931118d><animateMotion path=\"M60,32 L60,105 \" begin=\"0s\" dur=\"1.5s\" repeatCount=\"indefinite\" data-v-0931118d></animateMotion></circle><polygon points=\"40,85 32,81 40,97 48,81\" data-v-0931118d></polygon><circle cx=\"40\" cy=\"85\" r=\"1\" stroke-width=\"0\" data-v-0931118d></circle>", 5)
const _hoisted_31 = [
  _hoisted_26
]
const _hoisted_32 = { class: "ta-l" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "flow-icon-yd2"
}, null, -1))
const _hoisted_34 = {
  class: "dpIB posR",
  style: {"left":"10px","top":"20px"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Consumption")
], -1))
const _hoisted_36 = { class: "font-w fs16x" }
const _hoisted_37 = { class: "vaT" }
const _hoisted_38 = { class: "ta-r" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "flow-icon-dw2"
}, null, -1))
const _hoisted_40 = {
  class: "dpIB posR",
  style: {"top":"20px"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Grid")
], -1))
const _hoisted_42 = { class: "font-w fs16x" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 0,
  class: "pl10x"
}
const _hoisted_46 = { class: "LDash mb05x active-line" }
const _hoisted_47 = {
  version: "1.1",
  viewBox: "0 0 61.5 137",
  style: {"width":"61.5px","height":"137px"}
}
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<polyline points=\"49.5,12 49.5,125 12,125\" stroke-width=\"4\" class=\"polyLine\" style=\"fill:none;\" data-v-0931118d></polyline><circle cx=\"49.5\" cy=\"12\" r=\"6\" stroke-width=\"0\" data-v-0931118d></circle><circle cx=\"-20\" cy=\"-20\" r=\"6\" stroke-width=\"0\" fill=\"#4C87FF\" data-v-0931118d><animateMotion path=\"M69.5,32 L69.5,145 L32,145 \" begin=\"0s\" dur=\"3s\" repeatCount=\"indefinite\" data-v-0931118d></animateMotion></circle><polygon points=\"12,125 16,133 0,125 16,117\" data-v-0931118d></polygon><circle cx=\"12\" cy=\"125\" r=\"1\" stroke-width=\"0\" data-v-0931118d></circle>", 5)
const _hoisted_53 = [
  _hoisted_48
]
const _hoisted_54 = {
  key: 1,
  class: "pl10x"
}
const _hoisted_55 = { class: "LDash mb05x active-line" }
const _hoisted_56 = {
  version: "1.1",
  viewBox: "0 0 61.5 137",
  style: {"width":"61.5px","height":"137px"}
}
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<polyline points=\"12,125 25,125 25,12\" stroke-width=\"4\" class=\"polyLine\" style=\"fill:none;\" data-v-0931118d></polyline><circle cx=\"12\" cy=\"125\" r=\"6\" stroke-width=\"0\" data-v-0931118d></circle><circle cx=\"-20\" cy=\"-20\" r=\"6\" stroke-width=\"0\" fill=\"#4C87FF\" data-v-0931118d><animateMotion path=\"M32,145 L45,145 L45,32 \" begin=\"0s\" dur=\"3s\" repeatCount=\"indefinite\" data-v-0931118d></animateMotion></circle><polygon points=\"25,12 17,16 25,0 33,16\" data-v-0931118d></polygon><circle cx=\"25\" cy=\"12\" r=\"1\" stroke-width=\"0\" data-v-0931118d></circle>", 5)
const _hoisted_62 = [
  _hoisted_57
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.data.powerFromPV) + "kW", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_21))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_24, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_31))
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.data.currentPowerUsage) + "kW", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("span", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("span", _hoisted_42, [
                      (_ctx.isFromGrid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.data.powerFromGrid) + "kW ", 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.data.powerToTheGrid) + "kW ", 1))
                    ])
                  ])
                ]),
                (_ctx.isFromGrid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("span", _hoisted_46, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_47, _hoisted_53))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("span", _hoisted_55, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_62))
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}